import React from 'react';
import { useLocation } from 'react-router-dom';

function Footer(props) {
  const location = useLocation();
  const pathName = location.pathname;

  // Get the current year dynamically
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`footer py-3 ${pathName==='/password-generator'?'fixed-bottom':''} bg-${props.mode==='light'?'light':'dark'}`}>
      <div className="container">
        <p className={`text-center text-${props.mode==='light'?'dark':'light'} mb-0`}>Copyright &copy; {currentYear} - ZeeUtils - <a href="https://izeeshansalam.com" className='footer-link'>Zeeshan Salam</a></p>
      </div>
    </footer>
  )
}

export default Footer;